import { Box, Collapse, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Vector from "../../../../../../assets/images/svgs/VectorIcon.svg";
import { useAppStore } from "../../../../../../hooks/useStores";
import styles from "../TextToImageSearch.module.scss";

type Props = {
	className?: string;
};

const TextToImageError = ({ className }: Props) => {
	const { t, i18n } = useTranslation("translation", { keyPrefix: "playground.textToImage.errors" });
	const { textToImageStore } = useAppStore();
	const [open, setOpened] = useState(false);
	const [message, setMessage] = useState("");
	const isErrored = i18n.exists(`playground.textToImage.errors.${textToImageStore.errors?.generate?.message}`);
	useEffect(() => {
		if (isErrored) {
			setOpened(true);
			setMessage(t(`${textToImageStore.errors?.generate?.message}`));
		} else {
			setOpened(false);
			setMessage("");
		}
	}, [isErrored]);

	return (
		<Collapse in={open} onExited={() => (textToImageStore.errors = {})}>
			<Box className={`${styles.errorMessageContainer} ${className || ""}`}>
				<img src={Vector} />
				<Typography className={styles.errorMessage}>{message}</Typography>
			</Box>
		</Collapse>
	);
};

export default observer(TextToImageError);
